import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const Skeleton = (props: any) => {
  const { limit } = props;
  return (
    <>
      {limit === 5 ? (
        <div className={tw`grid grid-cols-5 gap-x-8 gap-y-4`}>
          {Array.from({ length: 10 }).map((_, index) => {
            return (
              <div
                key={index}
                className={tw`w-full bg-gray-200 animate-pulse p-10 rounded-md mb-8`}
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
              ></div>
            );
          })}
        </div>
      ) : (
        <div className={tw`grid grid-cols-3 gap-x-8 gap-y-4`}>
          {Array.from({ length: 3 }).map((_, index) => {
            return (
              <div
                key={index}
                className={tw`w-full bg-gray-200 animate-pulse p-10 rounded-md mb-8`}
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
              ></div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Skeleton;
